/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getOrderDetailsPage = (): Layout => ({
	name: 'SingleLayout',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'OrderHistoryDetails', id: 'order-history-details' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
